document.addEventListener('DOMContentLoaded', function () {
  if (window.__shopifyEngravingMineralInitialized) {
    return;
  }
  window.__shopifyEngravingMineralInitialized = true;

  const layoutMap = {
    й: 'q', ц: 'w', у: 'e', к: 'r', е: 't', н: 'y', г: 'u', ш: 'i', щ: 'o', з: 'p',
    ф: 'a', ы: 's', в: 'd', а: 'f', п: 'g', р: 'h', о: 'j', л: 'k', д: 'l', ж: ';', э: "'",
    я: 'z', ч: 'x', с: 'c', м: 'v', и: 'b', т: 'n', ь: 'm', б: ',', ю: '.', ё: '`',
    Й: 'Q', Ц: 'W', У: 'E', К: 'R', Е: 'T', Н: 'Y', Г: 'U', Ш: 'I', Щ: 'O', З: 'P',
    Х: '{', Ъ: '}', Ф: 'A', Ы: 'S', В: 'D', А: 'F', П: 'G', Р: 'H', О: 'J', Л: 'K',
    Д: 'L', Ж: ':', Э: '"', Я: 'Z', Ч: 'X', С: 'C', М: 'V', И: 'B', Т: 'N', Ь: 'M',
    Б: '<', Ю: '>', Ё: '~',
  };

  let lastSavedText = '';
  let lastSavedTemplate = '';
  let selectedTemplate = '';
  let selectedTemplatePreviewUrl = '';
  let currentWizardStep = 1;
  let isUpdatingAttributes = false;
  let confirmPopup = null;
  let templatesCache = null;

  function getLabels() {
    return (window.ShopifyEngravingMineralData && window.ShopifyEngravingMineralData.labels) || {};
  }

  function getWizardLabels() {
    const labels = getLabels();
    return labels.wizard || {};
  }

  function getMineralPopup() {
    return document.getElementById('mineralPopupOverlay');
  }

  function getMineralInput() {
    return document.getElementById('mineralEngraveInput');
  }

  function getMineralOption() {
    return document.getElementById('engravingMineralOption');
  }

  function getMineralPreviewSelected() {
    return document.getElementById('mineralEngravePreviewSelected');
  }

  function getMineralTemplateGrid() {
    return document.getElementById('mineralTemplateGrid');
  }


  function ensureEngravingLock() {
    if (window.StaleksEngravingLock) {
      return window.StaleksEngravingLock;
    }
    window.StaleksEngravingLock = {
      standard: false,
      mineral: false,
      set(type, active) {
        this[type] = !!active;
        this.refresh();
      },
      refresh() {
        const lock = (el, locked) => {
          if (!el) return;
          el.classList.toggle('engrave-option--locked', locked);
          el.setAttribute('aria-disabled', locked ? 'true' : 'false');
        };
        lock(document.getElementById('engravingOption'), this.mineral);
        lock(document.getElementById('engravingMineralOption'), this.standard);
      },
      isBlocked(type) {
        if (type === 'standard') return this.mineral;
        if (type === 'mineral') return this.standard;
        return false;
      },
    };
    return window.StaleksEngravingLock;
  }

  function parseJsonAttribute(raw) {
    if (!raw) return {};
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function pruneByCart(map, cartSkus) {
    if (cartSkus.length === 0) return map;
    Object.keys(map).forEach((key) => {
      if (!cartSkus.includes(key)) delete map[key];
    });
    return map;
  }

  function stringifyOrNull(map) {
    return Object.keys(map).length > 0 ? JSON.stringify(map) : null;
  }

  function getActiveSku() {
    const skuContainer = document.querySelector('product-info .product__sku, .product__sku');
    if (!skuContainer) {
      return 'UNKNOWN';
    }
    const spans = skuContainer.querySelectorAll('span');
    if (!spans.length) {
      return 'UNKNOWN';
    }
    return spans[spans.length - 1].innerText.trim();
  }

  function getProductTemplateShape() {
    const shape = window.ShopifyEngravingMineralData && window.ShopifyEngravingMineralData.templateShape;
    return shape === 'moon' || shape === 'straight' ? shape : null;
  }

  function isTemplateExcludedFromCatalog(name) {
    if (!name) {
      return true;
    }
    const lower = String(name).toLowerCase();
    return lower.startsWith('test-template') || lower.startsWith('test-') || lower.startsWith('test_');
  }

  function matchesProductTemplateShape(name) {
    const shape = getProductTemplateShape();
    if (!shape || !name) {
      return true;
    }
    const lower = String(name).toLowerCase();
    if (shape === 'moon') {
      return lower.includes('_moon');
    }
    return lower.includes('_straight');
  }

  function isFilledTemplate(name) {
    return !!name && String(name).toLowerCase().includes('_filled');
  }

  function parseMineralEntry(data) {
    if (!data) {
      return null;
    }
    const template = typeof data === 'string' ? '' : data.template || '';
    const text = typeof data === 'string' ? data : data.text || '';
    if (!template || !matchesProductTemplateShape(template)) {
      return null;
    }
    return { template, text: text || '' };
  }

  function hasActiveEngraving() {
    return !!lastSavedTemplate;
  }

  function getActiveTemplateName() {
    return selectedTemplate || lastSavedTemplate || '';
  }

  function isTextStepAvailable() {
    const tmpl = getActiveTemplateName();
    return !!tmpl && !isFilledTemplate(tmpl);
  }

  function getNextWizardStep(step) {
    if (step === 1) {
      return isTextStepAvailable() ? 2 : 3;
    }
    if (step === 2) {
      return 3;
    }
    return 3;
  }

  function getPrevWizardStep(step) {
    if (step === 3) {
      return isTextStepAvailable() ? 2 : 1;
    }
    if (step === 2) {
      return 1;
    }
    return 1;
  }

  function getInitialWizardStep() {
    return lastSavedTemplate ? 3 : 1;
  }

  function canNavigateToWizardStep(step) {
    if (step === 1) {
      return true;
    }
    if (!getActiveTemplateName()) {
      return false;
    }
    if (step === 2) {
      return isTextStepAvailable();
    }
    return step === 3;
  }

  function apiBaseUrl() {
    const d = window.ShopifyEngravingMineralData || {};
    return String(d.apiBase || 'https://staleks-shopify-main-vdu8nc.laravel.cloud').replace(/\/+$/, '');
  }

  function getMaxForTemplateName(name) {
    if (!name) {
      return 16;
    }
    if (name.includes('_straight')) {
      return 12;
    }
    if (name.includes('_moon')) {
      return 16;
    }
    return 16;
  }

  function getMaxSymbols() {
    const t = getActiveTemplateName();
    const fromMetafield = window.ShopifyEngravingMineralData && window.ShopifyEngravingMineralData.maxSymbolsDefault;
    if (fromMetafield && Number(fromMetafield) > 0) {
      return Math.min(Number(fromMetafield), getMaxForTemplateName(t));
    }
    return getMaxForTemplateName(t);
  }

  function getEngravePriceSuffix() {
    const opt = getMineralOption();
    const priceSpan = opt && opt.querySelector('.engrave-price');
    return priceSpan ? priceSpan.textContent : '';
  }

  function updatePriceAddon(show) {
    const productRoot = document.querySelector('product-info[id^="MainProduct-"], product-info');
    if (!productRoot || productRoot.closest('cart-drawer')) {
      return;
    }
    const priceBlock = productRoot.querySelector('[id^="price-"]');
    if (!priceBlock) {
      return;
    }
    let addonEl = priceBlock.querySelector('.engraving-mineral-addon-price');
    if (!addonEl) {
      addonEl = document.createElement('span');
      addonEl.className = 'engraving-mineral-addon-price';
      addonEl.style.cssText = 'margin-left:8px; color:#0071e3; font-weight:600; font-size:inherit;';
      priceBlock.appendChild(addonEl);
    }
    addonEl.textContent = show ? getEngravePriceSuffix() : '';
  }

  function renderPreviewBlock() {
    const pv = getMineralPreviewSelected();
    const labels = getLabels();
    if (!pv) {
      return;
    }
    if (!lastSavedTemplate) {
      pv.dataset.value = '';
      pv.dataset.template = '';
      pv.innerHTML = '';
      return;
    }
    pv.dataset.value = lastSavedText;
    pv.dataset.template = lastSavedTemplate;
    const txtLab = labels.text || 'Text';
    const tmplLab = labels.template || 'Template';
    const designLab = labels.designsWithoutText || 'Design';
    if (lastSavedText) {
      pv.innerHTML = `<span class="mineral-prev-line">${txtLab}: <strong>${lastSavedText}</strong></span>`;
    } else {
      pv.innerHTML = `<span class="mineral-prev-line">${tmplLab}: <strong>${designLab}</strong></span>`;
    }
  }

  function applyMineralUiState(hasEngraving) {
    const opt = getMineralOption();
    const labels = getLabels();
    const inp = getMineralInput();

    if (hasEngraving) {
      if (inp) {
        inp.value = lastSavedText;
      }
      if (opt) {
        opt.classList.add('engrave-added');
        const title = opt.querySelector('.engrave-option-title');
        if (title && labels.edit) {
          title.innerHTML = `${labels.edit} <span class="engrave-price">+€1</span>`;
        }
      }
      updatePriceAddon(true);
    } else {
      lastSavedText = '';
      lastSavedTemplate = '';
      selectedTemplate = '';
      selectedTemplatePreviewUrl = '';
      if (inp) {
        inp.value = '';
      }
      if (opt) {
        opt.classList.remove('engrave-added');
        const title = opt.querySelector('.engrave-option-title');
        if (title && labels.add) {
          title.innerHTML = `${labels.add} <span class="engrave-price">+€1</span>`;
        }
      }
      updatePriceAddon(false);
    }
    renderPreviewBlock();
    highlightSelectedTemplateChip();
    ensureEngravingLock().set('mineral', !!lastSavedTemplate);
  }

  function updateMineralCartAttributes() {
    if (isUpdatingAttributes) {
      return;
    }
    const sku = getActiveSku();
    isUpdatingAttributes = true;

    fetch('/cart.js', {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((r) => r.json())
      .then((cart) => {
        const cartSkus = cart.items.map((i) => i.sku).filter((s) => s);
        const attrs = cart.attributes || {};
        const mineral = pruneByCart(parseJsonAttribute(attrs.engraving_mineral), cartSkus);
        const standard = pruneByCart(parseJsonAttribute(attrs.engraving), cartSkus);

        if (lastSavedTemplate) {
          mineral[sku] = { template: lastSavedTemplate, text: lastSavedText || '' };
          delete standard[sku];
        } else {
          delete mineral[sku];
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            attributes: {
              engraving_mineral: stringifyOrNull(mineral),
              engraving: stringifyOrNull(standard),
            },
          }),
        });
      })
      .finally(() => {
        isUpdatingAttributes = false;
      });
  }

  function checkExistingMineralEngraving() {
    const sku = getActiveSku();

    fetch('/cart.js', {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((r) => r.json())
      .then((cart) => {
        const attrs = cart.attributes || {};
        const standard = parseJsonAttribute(attrs.engraving)[sku];
        const hasStandard = !!(standard && (typeof standard === 'string' ? standard : standard.text));
        if (hasStandard) {
          applyMineralUiState(false);
          return;
        }
        if (!cart.attributes || !cart.attributes.engraving_mineral) {
          applyMineralUiState(false);
          return;
        }

        const mineral = JSON.parse(cart.attributes.engraving_mineral);
        const entry = parseMineralEntry(mineral[sku]);

        if (entry) {
          lastSavedText = entry.text;
          lastSavedTemplate = entry.template;
          selectedTemplate = entry.template;
          applyMineralUiState(true);
          return;
        }

        applyMineralUiState(false);
      })
      .catch(() => {});
  }

  function filterTemplatesForProduct(items) {
    if (!Array.isArray(items)) {
      return [];
    }
    return items.filter((item) => !isTemplateExcludedFromCatalog(item.name) && matchesProductTemplateShape(item.name));
  }

  function highlightSelectedTemplateChip() {
    document.querySelectorAll('.mineral-template-chip').forEach((el) => {
      el.classList.toggle('selected', el.dataset.templateName === selectedTemplate);
    });
  }

  function partitionTemplateItems(items) {
    const regular = [];
    const filled = [];
    items.forEach((item) => {
      if (isFilledTemplate(item.name)) {
        filled.push(item);
      } else {
        regular.push(item);
      }
    });
    return { regular, filled };
  }

  function appendTemplateChip(gridEl, item) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mineral-template-chip';
    btn.dataset.templateName = item.name;
    btn.setAttribute('aria-label', item.name || 'Template');

    const swatch = document.createElement('span');
    swatch.className = 'mineral-template-chip-media';
    const img = document.createElement('img');
    img.src = item.url;
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    swatch.appendChild(img);
    btn.appendChild(swatch);

    btn.addEventListener('click', () => {
      selectedTemplate = item.name;
      selectedTemplatePreviewUrl = item.url || '';
      highlightSelectedTemplateChip();
      trimInputToMaxLength();
      applyTemplateSelectionEffects(item.name);
    });
    gridEl.appendChild(btn);
  }

  function renderTemplateChips(gridEl, items) {
    const labels = getLabels();
    gridEl.innerHTML = '';
    const { regular, filled } = partitionTemplateItems(items);
    regular.forEach((item) => appendTemplateChip(gridEl, item));
    if (filled.length > 0) {
      const heading = document.createElement('p');
      heading.className = 'mineral-template-section-heading';
      heading.textContent = labels.designsWithoutText || 'Designs without text';
      gridEl.appendChild(heading);
      filled.forEach((item) => appendTemplateChip(gridEl, item));
    }
    highlightSelectedTemplateChip();
    if (currentWizardStep === 3) {
      updateReviewPanel();
    }
  }

  function loadTemplatesIntoGrid(gridEl) {
    if (!gridEl) {
      return Promise.resolve([]);
    }
    if (templatesCache) {
      renderTemplateChips(gridEl, templatesCache);
      return Promise.resolve(templatesCache);
    }
    return fetch(apiBaseUrl() + '/api/v1/engraving/templates/mineral', {
      headers: { Accept: 'application/json' },
    })
      .then((res) => (res.ok ? res.json() : []))
      .then((items) => {
        templatesCache = filterTemplatesForProduct(items);
        renderTemplateChips(gridEl, templatesCache);
        return templatesCache;
      })
      .catch(() => []);
  }

  function resolveTemplatePreviewUrl(templateName) {
    if (!templateName) {
      return '';
    }
    if (selectedTemplate === templateName && selectedTemplatePreviewUrl) {
      return selectedTemplatePreviewUrl;
    }
    const selectedChipImg = document.querySelector('.mineral-template-chip.selected img');
    if (selectedChipImg) {
      return selectedChipImg.currentSrc || selectedChipImg.src;
    }
    const cached = templatesCache ? templatesCache.find((t) => t.name === templateName) : null;
    if (cached && cached.url) {
      return cached.url;
    }
    return `${apiBaseUrl()}/api/v1/engraving/templates/mineral/${encodeURIComponent(templateName)}/image`;
  }

  function getReviewTextForTemplate(templateName) {
    if (!templateName || isFilledTemplate(templateName)) {
      return '';
    }
    const inp = getMineralInput();
    return inp ? inp.value.trim() : '';
  }

  function isMobileMineralPreview() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function getReviewOverlayMaxWidth(text, templateName) {
    const len = [...text].length;
    const mobile = isMobileMineralPreview();
    if (mobile) {
      const base = String(templateName).includes('_moon') ? 46 : 52;
      const extra = Math.min(10, Math.max(0, (len - 5) * 1.1));
      return `${Math.min(60, base + extra)}%`;
    }
    const base = String(templateName).includes('_moon') ? 54 : 62;
    const extra = Math.min(14, Math.max(0, (len - 5) * 1.5));
    return `${Math.min(74, base + extra)}%`;
  }

  function fitReviewOverlayFontSize(overlayText, templateName, text) {
    const mobile = isMobileMineralPreview();
    const maxPx = mobile ? 11 : 24;
    const minPx = mobile ? 8 : 14;
    const media = overlayText.closest('.mineral-review-template-media');
    const maxWidthPx = media
      ? media.clientWidth * (parseFloat(getReviewOverlayMaxWidth(text, templateName)) / 100)
      : 0;

    let size = maxPx;
    overlayText.style.fontSize = `${size}px`;
    overlayText.style.letterSpacing = [...text].length > 10 ? '0.02em' : '0.05em';

    if (!maxWidthPx) {
      return;
    }

    while (size > minPx && overlayText.scrollWidth > maxWidthPx) {
      size -= 0.5;
      overlayText.style.fontSize = `${size}px`;
    }
  }

  function updateReviewTextOverlay(templateName, text) {
    const overlay = document.getElementById('mineralReviewTextOverlay');
    const overlayText = document.getElementById('mineralReviewTextOnTemplate');
    if (!overlay || !overlayText) {
      return;
    }

    overlay.classList.toggle('mineral-review-text-overlay--moon', String(templateName).includes('_moon'));
    overlay.classList.toggle('mineral-review-text-overlay--straight', String(templateName).includes('_straight'));

    if (!text) {
      overlayText.textContent = '';
      overlay.hidden = true;
      return;
    }

    overlayText.textContent = text;
    overlayText.style.maxWidth = getReviewOverlayMaxWidth(text, templateName);
    overlay.hidden = false;
    fitReviewOverlayFontSize(overlayText, templateName, text);
  }

  function updateReviewPanel() {
    const tmpl = selectedTemplate || lastSavedTemplate;
    const text = getReviewTextForTemplate(tmpl);
    const reviewTemplateImg = document.getElementById('mineralReviewTemplateImg');
    const previewUrl = resolveTemplatePreviewUrl(tmpl);

    if (reviewTemplateImg) {
      if (previewUrl) {
        reviewTemplateImg.src = previewUrl;
        reviewTemplateImg.hidden = false;
      } else {
        reviewTemplateImg.removeAttribute('src');
        reviewTemplateImg.hidden = true;
      }
      reviewTemplateImg.alt = tmpl || '';
    }

    updateReviewTextOverlay(tmpl, text);
  }

  function updateTextStepHint() {
    const hint = document.getElementById('mineralTextStepHint');
    const L = getWizardLabels();
    if (!hint || !L.maxCharsHint) {
      return;
    }
    hint.textContent = L.maxCharsHint.replace('{{ count }}', String(getMaxSymbols()));
  }

  function updateWizardActions() {
    const cancelBtn = document.getElementById('mineralCancelPopupBtn');
    const backBtn = document.getElementById('mineralBackBtn');
    const nextBtn = document.getElementById('mineralNextBtn');
    const saveBtn = document.getElementById('mineralSaveEngraveBtn');
    const removeBtn = document.getElementById('mineralRemoveEngraveBtn');

    if (cancelBtn) {
      cancelBtn.hidden = currentWizardStep !== 1;
    }
    if (backBtn) {
      backBtn.hidden = currentWizardStep === 1;
    }
    if (nextBtn) {
      nextBtn.hidden = currentWizardStep === 3;
      nextBtn.disabled = currentWizardStep === 1 && !selectedTemplate;
    }
    if (saveBtn) {
      saveBtn.hidden = currentWizardStep !== 3;
    }
    if (removeBtn) {
      removeBtn.hidden = !(hasActiveEngraving() || selectedTemplate);
    }
  }

  function updateWizardStepButtons() {
    const popup = getMineralPopup();
    if (!popup) {
      return;
    }
    popup.querySelectorAll('.mineral-wizard-step-num').forEach((btn) => {
      const step = Number(btn.dataset.step);
      const skipped = step === 2 && !isTextStepAvailable();
      btn.disabled = skipped || !canNavigateToWizardStep(step);
      btn.classList.toggle('is-skipped', skipped);
      if (step === currentWizardStep) {
        btn.classList.add('active');
        btn.setAttribute('aria-current', 'step');
      } else {
        btn.classList.remove('active');
        btn.removeAttribute('aria-current');
      }
      btn.classList.toggle('completed', step < currentWizardStep);
    });
  }

  function setWizardStep(step) {
    currentWizardStep = step;
    const popup = getMineralPopup();
    if (!popup) {
      return;
    }

    popup.dataset.wizardStep = String(step);
    popup.querySelectorAll('.mineral-wizard-panel').forEach((panel) => {
      panel.hidden = Number(panel.dataset.step) !== step;
    });

    updateWizardStepButtons();

    const desc = document.getElementById('mineralPopupDesc');
    const L = getWizardLabels();
    const descriptions = {
      1: L.descriptionTemplate,
      2: L.descriptionText,
      3: L.descriptionReview,
    };
    if (desc && descriptions[step]) {
      desc.textContent = descriptions[step];
    }

    updateWizardActions();

    if (step === 2) {
      updateTextStepHint();
      const inp = getMineralInput();
      if (inp) {
        setTimeout(() => inp.focus(), 100);
      }
    }

    if (step === 3) {
      requestAnimationFrame(updateReviewPanel);
    }
  }

  function applyTemplateSelectionEffects(templateName) {
    const inp = getMineralInput();
    if (inp && isFilledTemplate(templateName)) {
      inp.value = '';
    }
    if (currentWizardStep === 2 && isFilledTemplate(templateName)) {
      setWizardStep(3);
      return;
    }
    updateReviewPanel();
    updateWizardStepButtons();
    updateWizardActions();
  }

  function trimInputToMaxLength() {
    const inp = getMineralInput();
    if (!inp) {
      return;
    }
    const max = getMaxSymbols();
    const chars = [...inp.value];
    if (chars.length > max) {
      inp.value = chars.slice(0, max).join('');
    }
  }

  function showConfirmPopup(onConfirm, labelsOverride) {
    if (confirmPopup) {
      return;
    }
    const defaultLabels = getLabels().confirm || {};
    const L = labelsOverride || defaultLabels;
    confirmPopup = document.createElement('div');
    confirmPopup.className = 'popup-overlay confirm-popup';
    confirmPopup.style.zIndex = '10001';
    confirmPopup.innerHTML = `
      <div class="popup">
        <div class="popup-header">${L.title || 'Unsaved changes'}</div>
        <div class="popup-desc">${L.description || ''}</div>
        <div class="popup-actions">
          <button type="button" class="popup-cancel confirm-cancel">${L.cancel || 'Stay'}</button>
          <button type="button" class="popup-save confirm-leave">${L.confirm || 'Leave'}</button>
        </div>
      </div>`;
    document.body.appendChild(confirmPopup);
    confirmPopup.querySelector('.confirm-cancel').onclick = () => {
      document.body.removeChild(confirmPopup);
      confirmPopup = null;
    };
    confirmPopup.querySelector('.confirm-leave').onclick = () => {
      document.body.removeChild(confirmPopup);
      confirmPopup = null;
      onConfirm();
    };
  }

  function tryCloseMineralPopup() {
    const inp = getMineralInput();
    const popup = getMineralPopup();
    if (!inp || !popup) {
      return;
    }
    const textDirty =
      !isFilledTemplate(selectedTemplate || lastSavedTemplate) && inp.value.trim() !== lastSavedText;
    const tplDirty = (selectedTemplate || '') !== (lastSavedTemplate || '');
    if (textDirty || tplDirty) {
      showConfirmPopup(() => {
        inp.value = lastSavedText;
        selectedTemplate = lastSavedTemplate;
        highlightSelectedTemplateChip();
        popup.style.display = 'none';
        currentWizardStep = 1;
      });
    } else {
      popup.style.display = 'none';
      currentWizardStep = 1;
    }
  }

  function clearMineralEngraving() {
    lastSavedText = '';
    lastSavedTemplate = '';
    selectedTemplate = '';
    selectedTemplatePreviewUrl = '';
    updateMineralCartAttributes();
    applyMineralUiState(false);
  }

  function openMineralPopup() {
    if (ensureEngravingLock().isBlocked('mineral')) {
      return;
    }
    const popup = getMineralPopup();
    const grid = getMineralTemplateGrid();
    if (!popup || !grid) {
      return;
    }

    const inp = getMineralInput();
    if (inp) {
      inp.value = lastSavedText;
    }
    selectedTemplate = lastSavedTemplate || selectedTemplate || '';
    popup.style.display = 'flex';

    loadTemplatesIntoGrid(grid).then(() => {
      trimInputToMaxLength();
      if (selectedTemplate) {
        highlightSelectedTemplateChip();
      }
      setWizardStep(getInitialWizardStep());
    });
  }

  const priceObserver = new MutationObserver(() => {
    if (hasActiveEngraving() && !document.querySelector('.engraving-mineral-addon-price')) {
      updatePriceAddon(true);
    }
  });
  priceObserver.observe(document.body, { childList: true, subtree: true });

  const skuElem = document.querySelector('product-info .product__sku, .product__sku');
  if (skuElem) {
    new MutationObserver(() => {
      applyMineralUiState(false);
      setTimeout(checkExistingMineralEngraving, 300);
    }).observe(skuElem, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('variant:changed', () => {
    setTimeout(checkExistingMineralEngraving, 300);
  });

  if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
    window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(checkExistingMineralEngraving, 300);
    });
  }

  document.addEventListener('input', function (e) {
    if (!e.target || e.target.id !== 'mineralEngraveInput') {
      return;
    }
    const input = e.target;
    let start = input.selectionStart;
    let originalValue = input.value;
    let cleaned = '';
    for (let c of [...originalValue]) {
      const latin = layoutMap[c] || c;
      const uppercase = latin.toUpperCase();
      if (/[A-Z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(uppercase) && !/[{}/"]/.test(uppercase)) {
        cleaned += uppercase;
      }
    }
    const max = getMaxSymbols();
    const finalValue = [...cleaned].slice(0, max).join('');
    if (originalValue !== finalValue) {
      input.value = finalValue;
      const newPos = Math.min(start, finalValue.length);
      input.setSelectionRange(newPos, newPos);
    }
    if (currentWizardStep === 3) {
      updateReviewPanel();
    }
    updateWizardActions();
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('#mineralClosePopupBtn') || e.target.closest('#mineralCancelPopupBtn')) {
      tryCloseMineralPopup();
      return;
    }

    const popup = getMineralPopup();
    if (popup && e.target === popup) {
      tryCloseMineralPopup();
      return;
    }

    const stepBtn = e.target.closest('.mineral-wizard-step-num');
    if (stepBtn && popup && popup.contains(stepBtn)) {
      const step = Number(stepBtn.dataset.step);
      if (!Number.isNaN(step) && step !== currentWizardStep && canNavigateToWizardStep(step)) {
        setWizardStep(step);
      }
      return;
    }

    if (e.target.closest('#mineralRemoveEngraveBtn')) {
      const L = getLabels().removeConfirm || {};
      showConfirmPopup(() => {
        clearMineralEngraving();
        const p = getMineralPopup();
        if (p) {
          p.style.display = 'none';
          currentWizardStep = 1;
        }
      }, L);
      return;
    }

    if (e.target.closest('#mineralNextBtn')) {
      if (currentWizardStep === 1 && !selectedTemplate) {
        return;
      }
      setWizardStep(getNextWizardStep(currentWizardStep));
      return;
    }

    if (e.target.closest('#mineralBackBtn')) {
      if (currentWizardStep > 1) {
        setWizardStep(getPrevWizardStep(currentWizardStep));
      }
      return;
    }

    if (e.target.closest('#mineralSaveEngraveBtn')) {
      const inp = getMineralInput();
      const p = getMineralPopup();
      if (!inp || !p) {
        return;
      }
      const tmpl = selectedTemplate || lastSavedTemplate;
      if (!tmpl) {
        return;
      }
      lastSavedText = isFilledTemplate(tmpl) ? '' : inp.value.trim();
      lastSavedTemplate = tmpl;
      selectedTemplate = tmpl;
      updateMineralCartAttributes();
      applyMineralUiState(true);
      p.style.display = 'none';
      currentWizardStep = 1;
      return;
    }

    const mineralOption = e.target.closest('#engravingMineralOption, [data-mineral-engrave-trigger="1"]');
    if (!mineralOption) {
      return;
    }

    openMineralPopup();
  });

  const origFetch = window.fetch;
  window.fetch = function (...args) {
    return origFetch.apply(this, args).then((res) => {
      if (typeof args[0] === 'string' && args[0].includes('/cart/add')) {
        setTimeout(updateMineralCartAttributes, 500);
      }
      return res;
    });
  };

  checkExistingMineralEngraving();
});
